import { createContext } from "react";
const useGlobalAppContext=createContext({});
export default useGlobalAppContext;